<div *ngIf="show">
  <div class="loader-overlay">
    <div class="loader-message">
      {{ text }}
    </div>
    <div class="loader-content">
      <div class="lds-default">
        <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
  </div>
</div>